<template>
  <div class="tnc">
    <h1 class="xlarge-title">Terms of Service</h1>
    <p class="description">
      Selamat datang di ADX Asia!
Terima kasih telah mengunjungi website kami. Luangkan waktu anda untuk membaca Syarat dan Ketentuan ini sebelum membuat campaign di Situs kami. Dengan mengakses, menggunakan situs kami, dan membuat campaign di salah satu produk dan/atau lokasi kami, anda setuju untuk tunduk dan terikat pada Syarat dan Ketentuan website ini.
    </p>
    <h4>A. Definisi</h4>
    <div>
      1.
      <p>
        PT Narada Sahara Kencana adalah suatu perseroan terbatas yang menjalankan kegiatan usaha jasa web portal www.adxasia.co.id, yakni situs pencarian lokal untuk membuat campaign lebih mudah, murah dan cepat. Selanjutnya disebut “ADX Asia”.
      </p>
    </div>
    <div>
      2.
      <p>
        ADX Asia didirikan di Muara Karang Blok D 7 B No.46, Pluit, Penjaringan, Jakarta Utara – 14450.
      </p>
    </div>
    <div>
      3.
      <p>
        Situs ADX Asia adalah <a href="http://adxasia.co.id">www.adxasia.co.id</a>.
      </p>
    </div>
    <div>
      4.
      <p>
        Syarat dan Ketentuan adalah perjanjian antara Pengguna dan ADX Asia yang berisikan peraturan yang mengatur hak, kewajiban, tanggung jawab Pengguna, serta tata cara penggunaan ADX Asia.
      </p>
    </div>
    <div>
      5.
      <p>
        “Campaign” adalah serangkaian kegiatan maupun usaha penyampaian informasi tentang suatu produk dan hal lainnya melalui platform yang dimiliki oleh ADX Asia.
      </p>
    </div>
    <div>
      6.
      <p>
        “Akun” adalah Akun ADX Asia yang Anda perlukan untuk mendaftar di Situs jika Anda ingin melakukan pemesanan untuk pembuatan campaign.
      </p>
    </div>
    <div>
      7.
      <p>
        “Pengguna” adalah setiap orang yang mengakses Situs ADX Asia.
      </p>
    </div>
    <div>
      8.
      <p>
        “Pemesanan” adalah Pemesanan yang dibuat oleh Anda ke Situs untuk membuat campaign.
      </p>
    </div>
    <div>
      9.
      <p>
        “Anda” adalah Pengguna yang menempatkan Pemesanan.
      </p>
    </div>
    <h4>B. Persyaratan Pembuatan Campaign</h4>
    <div>
      1.
      <p>
        Pendaftaran
      </p>
    </div>
    <div>
      1.1
      <p>
        Untuk membuat campaign, Anda harus mendaftar dengan menciptakan Akun di Situs. Informasi yang ditetapkan dalam Syarat dan Ketentuan dan rincian yang terdapat di Situs ini bukan merupakan suatu penawaran untuk dijual melainkan undangan untuk melindungi. Untuk melakukan Pemesanan, Anda akan diminta untuk mengikuti proses pembuatan campaign di Situs. Sebuah Pemesanan hanya dianggap diterima oleh kami setelah Anda mengisi data dan melakukan proses Pemesanan sesuai dengan ketentuan di Situs.
      </p>
    </div>
    <div>
      1.2
      <p>
        Pengguna bertanggung jawab secara pribadi untuk menjaga kerahasiaan Akun dan password untuk semua aktivitas yang terjadi dalam Akun Pengguna.
      </p>
    </div>
    <div>
      1.3
      <p>
        Untuk membuat campaign, Anda harus mendaftar dengan menciptakan Akun di Situs. Informasi yang ditetapkan dalam Syarat dan Ketentuan dan rincian yang terdapat di Situs ini bukan merupakan suatu penawaran untuk dijual melainkan undangan untuk melindungi. Untuk melakukan Pemesanan, Anda akan diminta untuk mengikuti proses pembuatan campaign di Situs. Sebuah Pemesanan hanya dianggap diterima oleh kami setelah Anda mengisi data dan melakukan proses Pemesanan sesuai dengan ketentuan di Situs.
      </p>
    </div>
    <div>
      1.4
      <p>
        Pengguna dengan ini menyatakan membebaskan ADX Asia dari segala tanggung jawab atas kerugian apapun kendala yang timbul atas penyalahgunaan Akun Pengguna yang diakibatkan oleh kelalaian Pengguna, termasuk namun tidak terbatas pada meminjamkan atau memberikan akses Akun kepada pihak lain, memberikan atau memperlihatkan password atau email kepada pihak lain, maupun kelalaian Pengguna lainnya yang mengakibatkan kerugian ataupun kendala pada akun Pengguna.
      </p>
    </div>
    <div>
      2.
      <p>
        Harga dan Pembayaran
      </p>
    </div>
    <div>
      2.1
      <p>
        Pengguna wajib bertransaksi melalui prosedur transaksi yang telah ditetapkan oleh ADX Asia. Harga yang tercantum dalam Rupiah Indonesia. Anda akan membayar menggunakan salah satu mitra pembayaran yang terdaftar di Situs kami.
      </p>
    </div>
    <div>
      2.2
      <p>
        Anda dapat membayar seluruh atau sebagian dari harga Pesanan Anda menggunakan ADX Balance.
      </p>
    </div>
    <div>
      2.3
      <p>
        Saat melakukan Pemesanan, Pengguna menyetujui bertanggung jawab untuk membaca, memahami dan menyetujui informasi/deskripsi produk dan/atau lokasi sebelum membuat campaign.
      </p>
    </div>
    <div>
      2.4
      <p>
        Dengan melakukan Pemesanan, Pengguna menyetujui untuk membayar total biaya yang harus dibayarkan sebagaimana tertera dalam halaman pembayaran, yang terdiri dari jenis produk dan/atau lokasi, pajak dan biaya-biaya lain yang
mungkin timbul dan akan diuraikan secara tegas dalam halaman pembayaran.
      </p>
    </div>
    <div>
      3.
      <p>
        Pesanan Keliru
      </p>
    </div>
    <div>
      <p class="noNumber">
        Jika Anda menemukan bahwa Anda membuat kesalahan dengan Pesanan Anda dan telah membayarnya di Situs, silahkan hubungi customer service ADX Asia melalui email support@adxasia.co.id atau whatsapp ke +628 592 150 0014 segera. Kami
akan mencoba sebaik mungkin untuk memproses dan/atau menindak lanjuti permintaan Anda.
      </p>
    </div>
    <div>
      4.
      <p>
        Penolakan Pesanan
      </p>
    </div>
    <div>
      <p class="noNumber">
        Kami berhak untuk menunda penayangan, menarik setiap produk/produk dan/atau lokasi setiap saat dan/atau mengubah materi atau konten di Situs ini jika menurut kami tidak sesuai dengan norma dan ketentuan perundang-undangan yang berlaku.
Kami akan melakukan upaya terbaik kami untuk selalu memproses semua Pesanan tapi jika terjadi keadaan khusus sehingga kami perlu menolak memproses Pesanan sesuai dengan kebijakan kami dan Anda telah melakukan pembayaran untuk
Pesanan tersebut, jumlah pembayaran akan sepenuhnya dikembalikan kepada Anda berupa ADX Balance.
      </p>
    </div>
    <h4>C. Penayangan Campaign</h4>
    <div>
      1.
      <p>
        Jika menemui campaign tidak tayang pada produk dan/atau lokasi yang telah dipesan, Anda dapat langsung menghubungi customer service ADX Asia melalui email support@adxasia.co.id atau whatsapp ke +628 592 150 0014. Anda harus menunjukan bukti bahwa campaign Anda tidak tertayang pada produk dan/atau lokasi tersebut.
      </p>
    </div>
    <div>
      2.
      <p>
        Setiap klaim hanya akan diterima pada periode campaign dari produk dan/atau lokasi penayangan campaign yang telah dibuat dan dibayarkan oleh Pengguna.
      </p>
    </div>
    <div>
      3.
      <p>
        Jika sistem kami menemui pesanan Anda tidak tayang selama jam operasional, maka dana akan dikembalikan secara otomatis ke Akun Anda dalam bentuk ADX Balance.
      </p>
    </div>
    <h4>D. ADX Balance</h4>
    <div>
      1.
      <p>
        ADX Balance adalah saldo yang didapatkan oleh Pengguna dari :
      </p>
    </div>
    <div class="list">
      •
      <p>
        Pesanan yang sudah dibayarkan tidak tayang selama jam operasional pada produk dan/atau lokasi yang telah dipilih, sehingga dikembalikan secara otomatis ke Akun. Perhitungan pengembalian (refund) ditentukan oleh ADX Asia dan dapat berubah sewaktu-waktu.
      </p>
    </div>
    <div class="list">
      •
      <p>
        ADX Asia menolak pesanan yang telah Anda buat dan bayar.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Promo yang sewaktu-waktu diberikan oleh ADX Asia.
      </p>
    </div>
    <div>
      2.
      <p>
        Untuk saat ini, ADX Balance belum dapat diuangkan ataupun dipindahkan ke rekening pribadi.
      </p>
    </div>
    <h4>E. Promo</h4>
    <div>
      1.
      <p>
        Dari waktu ke waktu ADX Asia dapat mendistribusikan voucher promosi yang dapat digunakan hanya pada Situs dengan Syarat dan Ketentuan yang mungkin berbeda pada masing-masing kegiatan Promo. Pengguna dihimbau untuk membaca dengan seksama Syarat dan Ketentuan Promo tersebut. Kami mungkin melakukan pengecualian produk dan/atau lokasi pada voucher yang diberikan sesuai dengan strategi penjualan kami.
      </p>
    </div>
    <div>
      2.
      <p>
        ADX Asia berhak, tanpa pemberitahuan sebelumnya, melakukan tindakan-tindakan yang diperlukan termasuk namun tidak terbatas pada pencabutan Promo, membatalkan transaksi, serta hal-hal lainnya jika ditemukan adanya manipulasi, pelanggaran maupun pemanfaat Promo untuk keuntungan pribadi Pengguna, maupun indikasi kecurangan atau pelanggaran Syarat dan Ketentuan ADX Asia dan ketentuan hukum yang berlaku di wilayah Negara Indonesia.
      </p>
    </div>
    <h4>F. Tanggung Jawab</h4>
    <div>
      1.
      <p>
        Konten yang ditampilkan di Situs ini disediakan tanpa jaminan, kondisi atau garansi untuk akurasinya. Kecuali dinyatakan sebaliknya dan sejauh yang diizinkan oleh hukum, ADX Asia dan Host, serta penyedia konten dan pengiklan dengan tegas
      </p>
    </div>
    <h4>G. Jaminan dan Pengaduan Manajemen</h4>
    <div>
      1.
      <p>
        ADX Asia akan melaksanakan kewajibannya berdasarkan Syarat dan Ketentuan dengan sesuai. Kami menempatkan nilai besar pada kepuasan Pengguna kami. Anda dapat menghubungi kami setiap saat ke customer service ADX Asia melalui email support@adxasia.co.id atau whatsapp ke +628 592 150 0014 segera. Kami akan berusaha untuk mengatasi masalah Anda secepat mungkin dan akan menghubungi Anda untuk pemeriksaan berkaitan keluhan terkait.
      </p>
    </div>
    <div>
      2.
      <p>
        Dalam hal keluhan, akan sangat membantu kami jika Anda bisa menggambarkan keluhan Anda seakurat mungkin dan jika memungkinkan. Jika Anda tidak menerima tanggapan dari kami dalam waktu 5 (lima) Hari Kerja, silahkan kembali menghubungi kami.
      </p>
    </div>
    <h4>H. Force Majeure</h4>
    <div>
      1.
      <p>
        ADX Asia tidak bertanggung jawab kepada Anda untuk setiap pelanggaran, hambatan atau keterlambatan dalam pelaksanaan Kontrak disebabkan oleh apapun di luar kendali kami, termasuk namun tidak terbatas pada :
      </p>
    </div>
    <div class="list">
      •
      <p>
        Keributan sipil, kerusuhan, invasi, serangan teroris atau ancaman serangan teroris, perang (baik dinyatakan atau tidak) atau ancaman atau persiapan untuk perang.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Kebakaran, ledakan, badai, banjir, gempa bumi, longsor, wabah atau bencana alam lainnya.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Ketidakmungkinan penggunaan jaringan telekomunikasi publik atau swasta.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Tindakan, keputusan, undang-undang, peraturan atau pembatasan dari pemerintah, pengiriman, pos, atau aksi mogok transaksi lain yang berkaitan, kegagalan atau kecelakaan.
      </p>
    </div>
    <div>
      2.
      <p>
        Dalam keadaan bahwa peristiwa Force Majeure berlangsung selama lebih dari satu minggu, baik Anda atau kami dapat mengakhiri Kontrak segera dengan pemberitahuan tertulis dan tanpa Kewajiban.
      </p>
    </div>
    <div>
      3.
      <p>
        Kami memiliki kebijaksanaan mutlak pada solusi yang kami ambil dalam memenuhi kewajiban kami di bawah Kontrak meskipun terjadi Force Majeure.
      </p>
    </div>
    <h4>I. Hak Kekayaan Intelektual</h4>
    <div class="noNumber">
      <p>
        Kecuali ditentukan sebaliknya, seluruh konten termasuk dalam atau tersedia melalui Situs kami, seperti teks, grafik, logo, tombol ikon, gambar, klip audio, digital download, judul kampanye dan kompilasi data dimiliki atau dilindungi oleh hukum hak cipta milik ADX Asia. Informasi pada situs web ini dapat diunduh dan dicetak tanpa pembatasan untuk penggunaan pribadi dan tujuan non komersial lainnya, dan dapat dikutip sampai batasan yang wajar dalam karya lain dengan ketentuan mencantumkan sumber kutipan tersebut. Penggunaan lainnya atas isi situs web ini tanpa persetujuan tertulis terlebih dahulu dari ADX Asia secara tegas dilarang dan melanggar hukum hak kekayaan intelektual Indonesia dan peraturan terkait lainnya. 
      </p>
    </div>
    <h4>J. Larangan</h4>
    <div>
      1.
      <p>
        Anda tidak boleh menyalahgunakan Situs ini.
      </p>
    </div>
    <div>
      2.
      <p>
        Anda tidak boleh membuat campaign dengan jenis konten :
      </p>
    </div>
    <div class="list">
      •
      <p>
        Konten melanggar kesusilaan.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Konten perjudian.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Konten yang memuat penghinaan dan atau pencemaran nama baik.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Konten pemerasan atau pengancaman.
      </p>
    </div>
    <div class="list">
      •
      <p>
        Konten yang menyebabkan permusuhan isu SARA.
      </p>
    </div>
    <div>
      3.
      <p>
        Anda tidak akan melakukan atau mendukung tindak pidana, mengirimkan atau mendistribusikan virus termasuk Trojan horse, worm, logic bomb atau mengirimkan materi berbahaya lainnya pada Situs, teknologi berbahaya, melanggar kepercayaan atau dengan cara apapun yang bersifat ofensif atau melecehkan; merusak data; menyebabkan gangguan terhadap pengguna lain; melanggar hak kesopanan orang lain; mengirim iklan atau materi promosi yang tidak diminta; atau mencoba untuk mempengaruhi kinerja atau fungsi dari setiap computer atau akses terhadap seluruh Situs.
      </p>
    </div>
    <div>
      4.
      <p>
        Setiap pelangggaran terhadap syarat dan ketentuan ini merupakan tindak pidana di bawah Undang-Undang Nomor 11 Tahun 2008 tentang Internet dan Transaksi Elektronik (ITE). Jika hal tersebut terjadi, ADX Asia berhak melaporkan kepada pihak penegak hukum yang berwenang dan mengambil tindakan hukum yang tepat.
      </p>
    </div>
    <h4>K. Pembaruan</h4>
    <div>
      1.
      <p>
        Setiap usaha dilakukan untuk memastikan bahwa informasi dalam situs web ini akurat dan terkini. Kami berhak dari waktu ke waktu untuk memodifikasi, melakukan perubahan, perbaikan atau membatasi akses atau menutup situs web ini, tanpa pemberitahuan terlebih dahulu. ADX Asia tidak memberikan komitmen untuk memutakhirkan setiap informasi yang terdapat dalam situs web ini.
      </p>
    </div>
    <div>
      2.
      <p>
        Syarat dan Ketentuan mungkin diubah dan/atau diperbaharui dari waktu ke waktu tanpa pemberitahuan sebelumnya. ADX Asia menghimbau Anda membaca secara seksama dan memeriksa halaman Syarat dan Ketentuan ini dari waktu ke waktu untuk mengetahui perubahan apapun. Dengan tetap mengakses dan menggunakan Situs ADX Asia, maka Pengguna dianggap menyetujui perubahan-perubahan dalam Syarat dan Ketentuan.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-tnc',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>